export * from "./tag-list.resolver";
export * from "./tag-list.component";
